import type { ChangeEvent } from 'react';
import {
  AI_RESPONSE_MODE_OPTIONS,
  type AiResponseMode,
  aiResponseModeSchema,
} from '@pirouette/shared';

export interface AiResponseModeSelectorProps {
  value: AiResponseMode;
  onChange: (mode: AiResponseMode) => void;
  id?: string;
  label?: string;
  descriptionId?: string;
}

export function AiResponseModeSelector({
  value,
  onChange,
  id = 'ai-response-mode',
  label = 'AI review mode',
  descriptionId,
}: AiResponseModeSelectorProps) {
  const selectedMode = AI_RESPONSE_MODE_OPTIONS.find((mode) => mode.value === value);

  function handleChange(event: ChangeEvent<HTMLSelectElement>) {
    onChange(aiResponseModeSchema.parse(event.target.value));
  }

  return (
    <div className="space-y-2">
      <label htmlFor={id} className="block font-medium text-[var(--text-sm)]">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={handleChange}
        aria-describedby={descriptionId}
        className="h-10 w-full rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-surface)] px-3 text-[var(--text-sm)]"
      >
        {AI_RESPONSE_MODE_OPTIONS.map((mode) => (
          <option key={mode.value} value={mode.value}>
            {mode.uiLabel}
          </option>
        ))}
      </select>
      {selectedMode && (
        <p id={descriptionId} className="text-[var(--color-ink-muted)] text-[var(--text-xs)]">
          {selectedMode.description}
        </p>
      )}
    </div>
  );
}
